export const ADMIN_DEFLECT_ANALYTICS_SLICE_NAME = "adminDeflectAnalytics"
